import { useState } from "react";
import { CheckCircle2, Phone, MessageSquare } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SITE } from "@/lib/config";
import { trackConversion } from "@/lib/analytics";
import { useFormSubmit, submitBtnCls } from "@/lib/forms";
import { CallLink, TextLink } from "@/components/TrackedLinks";
import { QuoteFields } from "@/components/catering/QuoteFields";

const initial = { name: "", phone: "", email: "", eventDate: "", eventType: "", guestCount: "", serviceType: "", venueOrZip: "", desiredPackage: "", budget: "", additionalInfo: "", hearAbout: "" };

const QuoteSuccess = () => {
  const { t } = useLang();
  return (
    <div className="bg-hacienda-cream rounded-2xl p-10 text-center" role="status" data-testid="quote-success">
      <CheckCircle2 size={48} className="text-hacienda-terracotta mx-auto mb-4" aria-hidden="true" />
      <h3 className="font-serif text-3xl text-hacienda-charcoal font-semibold mb-3">{t("catering.successTitle")}</h3>
      <p className="text-hacienda-gray max-w-lg mx-auto mb-8">{t("catering.successCopy")}</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <CallLink location="quote_success" variant="primary"><Phone size={18} /> {SITE.phoneDisplay}</CallLink>
        <TextLink location="quote_success"><MessageSquare size={18} /> {t("actions.text")}</TextLink>
      </div>
    </div>
  );
};

export const CateringQuoteForm = () => {
  const { t, lang } = useLang();
  const [form, setForm] = useState(initial);
  const { status, submit } = useFormSubmit("catering-quote", () =>
    trackConversion("catering_form_submit", { event_type: form.eventType, guests: form.guestCount }),
  );
  const onChange = (e) => setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  if (status === "success") return <QuoteSuccess />;

  return (
    <form onSubmit={(e) => { e.preventDefault(); submit({ ...form, language: lang }); }} className="bg-hacienda-cream rounded-2xl p-6 sm:p-10 space-y-6" data-testid="catering-quote-form">
      <QuoteFields form={form} onChange={onChange} />
      {status === "error" && <p className="text-red-700 text-sm" role="alert" data-testid="quote-error">{t("vip.error")}</p>}
      <button type="submit" disabled={status === "loading"} className={`w-full sm:w-auto px-10 py-3.5 ${submitBtnCls}`} data-testid="quote-submit-btn">
        {status === "loading" ? t("actions.sending") : t("catering.f.submit")}
      </button>
    </form>
  );
};
